var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 30 32",
    id: "Filled_Outline",
    viewBox: "0 0 35 58",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#F2B035",
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,26c-5.514,0-10-4.486-10-10S10.486,6,16,6s10,4.486,10,10S21.514,26,16,26z M16,8    c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S20.411,8,16,8z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 4,
    width: 2,
    x: 15
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -2.5269 6.1006)",
    width: 2,
    x: 5.101,
    y: 4.101
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 2,
    width: 4,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.5268 11.8995)",
    width: 4,
    x: 4.101,
    y: 24.9
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 4,
    width: 2,
    x: 15,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.7279 25.8994)",
    width: 2,
    x: 24.9,
    y: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 2,
    width: 4,
    x: 28,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F2B035",
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3.272 20.1005)",
    width: 4,
    x: 23.9,
    y: 5.101
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.c303cc0811c88b2e0d740959532de605.svg";
export { ForwardRef as ReactComponent };